<template>
   <div
    class="country-selector"
    v-if="shouldShowSection">
    <header>
      <div>
        <ns-icon icon-name="icon-info-filled" />
      </div>
      <h3>{{ tdc.tdc_otherMarketsTitle }}</h3>
    </header>
    <div class="content">
      <div class="country-selector-dropdown">
        <NsSelect
          :id="countrySelect"
          class="country-select ns-select"
          :items="dropdownModel"
          :value="selectedValue"
          @input="selectCountry"/>
        <button class="primary-solid select-country-button" @click="goToSelectedCountry()">{{ tdc.tdc_goButton }}</button>
      </div>
      <p>{{ tdc.tdc_otherMarketsDisclaimer }}</p>
    </div>
   </div>
</template>
<script>

import {
  MarketSiteRegionsV2,
  RunConfigService
} from '@nuskin/ns-util'

import { NsIcon } from '@nuskin/ns-icon'
import { NsSelect } from '@nuskin/design-components'

export default {
  props: {
    tdc: {
      default: () => {},
      type: Object
    },
    qualifications: {
      default: () => {},
      type: Object
    }
  },
  watch: {
    qualifications: function() {
      this.buildCountriesObject()
    }
  },
  components: {
    NsSelect,
    NsIcon
  },
  data() {
    return {
      countriesList: [],
      dropdownModel: [],
      selectedValue: null
    }
  },
  methods: {
    async buildCountriesObject() {
      const qualificationCountries = new Set(
        Object.values(this.qualifications)
          .filter(qualification => qualification.quantity > 0 ||
          qualification.sharedList.reduce((total, sharedItem) => total + sharedItem.canReclaim, 0) > 0
          )
          .map(qualification => qualification.markets)
          .flat()
      )

      this.countriesList = (await MarketSiteRegionsV2.getMarketSiteRegionData())
        .map(region => region.countryname)
        .flat()
        .filter(country => qualificationCountries.has(country.countryCode))

      const language = RunConfigService.getRunConfig().language
      this.dropdownModel = this.countriesList.map(country => {
        return {
          text: country.locale_names[language],
          value: country.countryCode
        }
      })
      this.selectedValue = { value: RunConfigService.getRunConfig().country }
    },
    selectCountry(countryCode) {
      this.selectedValue = {
        value: countryCode
      }
    },
    goToSelectedCountry() {
      const countryConfig = this.countriesList.find(country => country.countryCode === this.selectedValue.value)
      const languageCode = countryConfig.defaultLocale.defaultLanguageCode
      const path = window.location.origin + window.location.pathname + `?locale=${languageCode}_${this.selectedValue.value}`

      window.location.href = path
    }
  },
  computed: {
    shouldShowSection() {
      return (
        this.countriesList.length > 1 || (this.countriesList.length === 1 && this.countriesList[0].countryCode !== RunConfigService.getRunConfig().country)
      )
    }
  },
  mounted() {
    this.buildCountriesObject()
  }
}
</script>


<style lang="scss" scoped>

.country-select {
  width: 250px;
}

@media (max-width: 545px) {
  .country-selector {
    border: none;
    padding-top: 20px;
    margin-bottom: 40px;
    max-width: 90%;
    box-shadow: rgb(0 0 0 / 15%) 0 8px 8px 0;

    .content {
      flex-direction: column;
      width: 100%;

      > div {
        width: 100%;
        margin-bottom: 10px;
      }
    }
  }
}

@media (min-width: 546px) and (max-width: 1023px) {
  .country-selector {
    border: none;
    max-width: 90%;
    box-shadow: rgb(0 0 0 / 15%) 0 8px 8px 0;
  }
}

.country-selector {
  background: white;
  border-top: 8px solid var(--notice-color);
  width: 860px;
  margin: 0 auto 20px;
  padding: 10px 10px;
  box-sizing: border-box;
  box-shadow: rgb(0 0 0 / 15%) 0 8px 8px 0;

  header {
    display: flex;
    width: 800px;
    max-width: 100%;
    margin: auto;
    text-align: left;
    margin-bottom: 10px;

    h3 {
      line-height: 24px;
      font-size: 18px;
      font-weight: var(--font-weight-semibold);
      font-family: var(--font-family-primary);
    }
  }

  .content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 740px;
    max-width: 100%;
    margin: 0 auto 10px;

    .country-selector-dropdown {
      display: flex;
      justify-content: space-around;
      align-items: center;

      button {
        margin-left: 25px;
      }
    }
  }

  .icon {
    color: var(--notice-color);
    margin-right: 5px;
    height: 28px;
    width: 28px;
  }

  > div {
    display: flex;
    width: 48%;
    justify-content: space-between;
    align-items: center;

  }

  ns-slotted-dropdown {
    margin-right: 6px;
  }

  p {
    font-size: 14px;
    font-weight: var(--font-weight-medium);
    line-height: 18px;
    max-width: 380px;
  }
}

</style>
